import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./App.css";
import "../src/Component/Modal/Modal.css";
import Home from "../src/View/Home/Index";
import Login from "./Athentication/Login";

import MainLayout from "./Layout/MainLayout";
import Privateroute from "./PrivateRoute/Privateroute";
import AddCity from "./View/Pages/City/addCity";
import ManageCity from "./View/Pages/City/ManageCity";
import AddPropertyType from "./View/Pages/PropertyType/AddPropertyType";
import ManagePropertyType from "./View/Pages/PropertyType/ManagePropertyType";
import AddBhk from "./View/Pages/BHK/AddBhk";
import ManageBhk from "./View/Pages/BHK/ManageBhk";
import AddFloor from "./View/Pages/Floor/AddFloor";
import ManageFloor from "./View/Pages/Floor/ManageFloor";
import AddProperty from "./View/Pages/Property/AddProperty";
import ManageProperty from "./View/Pages/Property/ManageProperty";
import AddSubscription from "./View/Pages/Subscription/AddSubscription";
import ManageSubscription from "./View/Pages/Subscription/ManageSubscription";
import AddBanner from "./View/Pages/Banner/AddBanner";
import AddAdvertisement from "./View/Pages/Advertisement/AddAdvertisement";
import ManageAdvertisement from "./View/Pages/Advertisement/ManageAdvertisement";
import AdvertisementEnquiries from "./View/Pages/Advertisement/AdvertisementEnquiries";
import AddFacing from "./View/Pages/Facing/AddFacing";
import ManageFacing from "./View/Pages/Facing/ManageFacing";
import AddDesignation from "./View/Pages/Designation/AddDesignation";
import ManageDesignation from "./View/Pages/Designation/ManageDesignation";
import AddStaff from "./View/Pages/Staff/AddStaff";
import ManageStaff from "./View/Pages/Staff/ManageStaff";
import AddLocality from "./View/Pages/Locality/AddLocality";
import ManageLocality from "./View/Pages/Locality/ManageLocality";
import AddUser from "./View/Pages/User/AddUser";
import ManageUser from "./View/Pages/User/ManageUser";
import AddBasicUser from "./View/Pages/BasicUser/AddBasicUser";
import ManageBasicUser from "./View/Pages/BasicUser/ManageBasicUser";
import AddSociety from "./View/Pages/Society/AddSociety";
import AddCommunity from "./View/Pages/Community/AddCommunity";
import AddInventory from "./View/Pages/Inventory/AddInventory";
import ManageSociety from "./View/Pages/Society/ManageSociety";
import ManageCommunity from "./View/Pages/Community/ManageCommunity";
import ManageInventory from "./View/Pages/Inventory/ManageInventory";
import Sales from "./View/Pages/Sales/Sales.jsx";
import AddApartment from "./View/Pages/Apartment/AddApartment.jsx";
import AddCommission from "./View/Pages/Commission/AddCommission.jsx";
import AddRent from "./View/Pages/Rent/AddRent.jsx";
import AddElectricity from "./View/Pages/Electricity/AddElectricity.jsx";
import AddTelephoneInternet from "./View/Pages/TelephoneInternet/AddTelephoneInternet.jsx";
import AddPetrol from "./View/Pages/Petrol/AddPetrol.jsx";
import AddMiscellaneous from "./View/Pages/Miscellaneous/AddMiscellaneous.jsx";
import ManageCommission from "./View/Pages/Commission/ManageCommission.jsx";
import ManageRent from "./View/Pages/Rent/ManageRent.jsx";
import ManageElectricity from "./View/Pages/Electricity/ManageElectricity.jsx";
import ManageTelephoneInternet from "./View/Pages/TelephoneInternet/ManageTelephoneInternet.jsx";
import ManagePetrol from "./View/Pages/Petrol/ManagePetrol.jsx";
import ManageMiscellaneous from "./View/Pages/Miscellaneous/ManageMiscellaneous.jsx";
import ManageApartment from "./View/Pages/Apartment/ManageApartment.jsx";
import ExpenseReport from "./View/Pages/Report/ExpenseReport.jsx";
import EmailToStaff from "./View/Pages/SendEmail/EmailToStaff.jsx";
import HotClientList from "./View/Pages/HotClients/HotClientList.jsx";
import AddSalesPipeline from "./View/Pages/SalesPipeline/AddSalesPipeline.jsx";
import ManageSalesPipeline from "./View/Pages/SalesPipeline/ManageSalesPipeline.jsx";
import SentEmailsToStaff from "./View/Pages/SendEmail/SentEmailsToStaff.jsx";
import AddMenuAccess from "./View/Pages/MenuAccess/AddMenuAccess.jsx";
import AddSalary from "./View/Pages/Salary/AddSalary.jsx";
import ManageSalary from "./View/Pages/Salary/ManageSalary.jsx";
import Worksheet from "./View/Pages/Worksheet/Worksheet.jsx";
import DynamicTable from "./View/Pages/RND/DynamicTable.jsx";
import AddBlog from "./View/Pages/Blog/AddBlog.jsx";
import ManageBlog from "./View/Pages/Blog/ManageBlog.jsx";
import UserRemarks from "./View/Pages/Property/UserRemarks.jsx";
import DeletedWorksheet from "./View/Pages/DeletedData/DeletedWorksheet.jsx";
import ClientListing from "./View/Pages/Deals/ClientListing.jsx";
import AddJobCategory from "./View/Pages/Job/AddJobCategory.jsx";
import ManageJobCategory from "./View/Pages/Job/ManageJobCategory.jsx";
import AddJobPost from "./View/Pages/Job/AddJobPost.jsx";
import ManageJobPosts from "./View/Pages/Job/ManageJobPosts.jsx";
import ManageBanner from "./View/Pages/Banner/ManageBanner.jsx";
import JobApplications from "./View/Pages/Job/JobApplications.jsx";
import ManagePromotion from "./View/Pages/Promotion/ManagePromotion.jsx";
import AddPromotion from "./View/Pages/Promotion/addPromotion.jsx";
import AddBlogCategory from "./View/Pages/Blog/AddBlogCategory.jsx";
import ManageBlogCategory from "./View/Pages/Blog/ManageBlogCategory.jsx";
import AddReels from "./Reels/AddReels.jsx";
import ManageReels from "./Reels/ManageReels.jsx";
import AddAdvertisementNew from "./AdvertisementNew/AddAdvertisementNew.jsx";
import ManageAdvertisementNew from "./AdvertisementNew/ManageAdvertisementNew.jsx";
import ViewReportProperty from "./ReportProperty/ViewReportProperty.jsx";
import AddCityDetails from "./CityDetails/AddCityDetails.jsx";
import ManageCityDetails from "./CityDetails/ManageCityDetails.jsx";
import AddPrimeLocationInsights from "./PrimeLocationInsights/AddPrimeLocationInsights.jsx";
import ManagePrimeLocationInsights from "./PrimeLocationInsights/ManagePrimeLocationInsights.jsx";
import AddPersonalService from "./PersonalService/AddPersonalService.jsx";
import ManagePersonalService from "./PersonalService/ManagePersonalService.jsx";
import AddWallOfFrame from "./WallOfFrame/AddWallOfFrame.jsx";
import ManageWallOfFrame from "./WallOfFrame/ManageWallOfFrame.jsx";
import AddPeopleSaying from "./PeopleSaying/AddPeopleSaying.jsx";
import ManagePeopleSaying from "./PeopleSaying/ManagePeopleSaying.jsx";
import AddFaq from "./FAQ/AddFaq.jsx";
import ManageFaq from "./FAQ/ManageFaq.jsx";
import AddAppPoster from "./AppPoster/AddAppPoster.jsx";
import ManageAppPoster from "./AppPoster/ManageAppPoster.jsx";
import AddAdvertisementShowingOrder from "./AdvertisementShowingOrder/AddAdvertisementShowingOrder.jsx";
import ManageAdvertisementShowingOrder from "./AdvertisementShowingOrder/ManageAdvertisementShowingOrder.jsx";
import AddFooterMenu from "./FooterMenu/AddFooterMenu.jsx";
import ManageFooterMenu from "./FooterMenu/ManageFooterMenu.jsx";
import AddDealerSection from "./Dealer/AddDealerSection.jsx";
import ManageDealerSection from "./Dealer/ManageDealerSection.jsx";
import AddHighlightedProject from "./HighlightedProject/AddHighlightedProject.jsx";
import ManageHighlightedProject from "./HighlightedProject/ManageHighlightedProject.jsx";
import EditProperty from "./View/Pages/Property/EditProperty.jsx";
const App = () => {
  // const [userRole, setUserRole] = useState(localStorage.getItem("role"));
  // console.log("role", userRole);
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Privateroute />}>
            <Route element={<MainLayout />}>
              {/* {userRole === "survey" ? (
                <Route path="/" element={<ManageUser />} />
              ) : (
                <Route path="/" element={<Home />} />
              )} */}
              <Route path="/" element={<Home />} />

              {/* Users Route */}
              {/* <Route path="/manage-user" element={<ManageUser />} />
              <Route path="/manage-user-curior" element={<ManageCurior />} />
              <Route path="/manage-user-rights" element={<ManageUserRights />} /> */}

              {/* City Route */}
              <Route path="/add-city" element={<AddCity />} />
              <Route path="/manage-city" element={<ManageCity />} />

              {/* City Details */}
              <Route path="/add-city-details" element={<AddCityDetails />} />
              <Route
                path="/manage-city-details"
                element={<ManageCityDetails />}
              />

              {/* Property Type Route */}
              <Route path="/add-property-type" element={<AddPropertyType />} />
              <Route
                path="/manage-property-type"
                element={<ManagePropertyType />}
              />

              {/* BHK Route */}
              <Route path="/add-bhk" element={<AddBhk />} />
              <Route path="/manage-bhk" element={<ManageBhk />} />

              {/* Floor Route */}
              <Route path="/add-floor" element={<AddFloor />} />
              <Route path="/manage-floor" element={<ManageFloor />} />

              {/* Property Route */}
              <Route path="/add-property" element={<AddProperty />} />
              <Route path="/manage-property" element={<ManageProperty />} />
              <Route path="/property/edit/:id" element={<EditProperty />} />

              {/*Prime Location Insights*/}
              <Route
                path="/add-prime-location-insights"
                element={<AddPrimeLocationInsights />}
              />
              <Route
                path="/manage-prime-location-insights"
                element={<ManagePrimeLocationInsights />}
              />
              {/* Advertisement Showing Order */}
              <Route
                path="/add-advertisement-showing-order"
                element={<AddAdvertisementShowingOrder />}
              />
              <Route
                path="/manage-advertisement-showing-order"
                element={<ManageAdvertisementShowingOrder />}
              />
              {/* people saying */}
              <Route path="/add-people-saying" element={<AddPeopleSaying />} />
              <Route
                path="/manage-people-saying"
                element={<ManagePeopleSaying />}
              />
              {/* Footer Menu */}
              <Route path="/add-footer-menu" element={<AddFooterMenu />} />
              <Route
                path="/manage-footer-menu"
                element={<ManageFooterMenu />}
              />
              {/* Dealer Section */}
              <Route
                path="/add-dealer-section"
                element={<AddDealerSection />}
              />
              <Route
                path="/manage-dealer-section"
                element={<ManageDealerSection />}
              />
              {/* Highlighted Project Section */}
              <Route
                path="/add-highlighted-project"
                element={<AddHighlightedProject />}
              />
              <Route
                path="/manage-highlighted-project"
                element={<ManageHighlightedProject />}
              />
              {/* faq */}
              <Route path="/add-faq" element={<AddFaq />} />
              <Route path="/manage-faq" element={<ManageFaq />} />
              {/* App poster */}
              <Route path="/add-app-poster" element={<AddAppPoster />} />
              <Route path="/manage-app-poster" element={<ManageAppPoster />} />

              {/* personal Service */}
              <Route
                path="/add-personal-service"
                element={<AddPersonalService />}
              />
              <Route
                path="/manage-personal-service"
                element={<ManagePersonalService />}
              />
              {/* wall of fame */}
              <Route path="/add-wall-of-fame" element={<AddWallOfFrame />} />
              <Route
                path="/manage-wall-of-fame"
                element={<ManageWallOfFrame />}
              />

              {/* User Route */}
              <Route path="/add-user" element={<AddUser />} />
              {/* <Route path="/view-user-list" element={<UserList />} /> */}
              <Route path="/manage-user" element={<ManageUser />} />

              {/* Basic User Routes */}
              <Route path="/add-basic-user" element={<AddBasicUser />} />
              <Route path="/manage-basic-user" element={<ManageBasicUser />} />

              {/* Subscription Route */}
              <Route path="/add-subscription" element={<AddSubscription />} />
              <Route
                path="/manage-subscription"
                element={<ManageSubscription />}
              />

              {/* Banner Route */}
              <Route path="/add-banner" element={<AddBanner />} />
              <Route path="/manage-banner" element={<ManageBanner />} />

              {/* Advertisement Route */}
              <Route path="/add-advertisement" element={<AddAdvertisement />} />
              <Route
                path="/manage-advertisement"
                element={<ManageAdvertisement />}
              />
              <Route path="/advertisement-enquiries" element={<AdvertisementEnquiries />} />

              {/* Facing Route */}
              <Route path="/add-facing" element={<AddFacing />} />
              <Route path="/manage-facing" element={<ManageFacing />} />

              {/* Desigation Route */}
              <Route path="/add-designation" element={<AddDesignation />} />
              <Route
                path="/manage-designation"
                element={<ManageDesignation />}
              />

              {/* Report Property */}
              <Route
                path="/view-report-property"
                element={<ViewReportProperty />}
              />

              {/* Staff Route */}
              <Route path="/add-staff" element={<AddStaff />} />
              <Route path="/manage-staff" element={<ManageStaff />} />

              {/* Locality Route */}
              <Route path="/add-locality" element={<AddLocality />} />
              <Route path="/manage-locality" element={<ManageLocality />} />

              {/*Advertisement for cities*/}
              <Route
                path="/add-advertisement-for-city"
                element={<AddAdvertisementNew />}
              />
              <Route
                path="/manage-advertisement-for-city"
                element={<ManageAdvertisementNew />}
              />

              {/* Facing Route */}
              <Route path="/add-apartment" element={<AddApartment />} />
              <Route path="/manage-apartment" element={<ManageApartment />} />

              {/* Socity Route */}
              <Route path="/add-society" element={<AddSociety />} />
              <Route path="/manage-society" element={<ManageSociety />} />

              {/* Community Route */}
              <Route path="/add-community" element={<AddCommunity />} />
              <Route path="/manage-community" element={<ManageCommunity />} />

              {/* Inventory Route */}
              <Route path="/add-inventory" element={<AddInventory />} />
              <Route path="/manage-inventory" element={<ManageInventory />} />

              {/* Sales Route */}
              <Route path="/sales" element={<Sales />} />

              {/* Commission Route */}
              <Route path="/add-commission" element={<AddCommission />} />
              <Route path="/manage-commission" element={<ManageCommission />} />

              {/* Salary Route */}
              <Route path="/add-salary" element={<AddSalary />} />
              <Route path="/manage-salary" element={<ManageSalary />} />

              {/* Rent Route */}
              <Route path="/add-rent" element={<AddRent />} />
              <Route path="/manage-rent" element={<ManageRent />} />

              {/* Electricity Route */}
              <Route path="/add-electricity" element={<AddElectricity />} />
              <Route
                path="/manage-electricity"
                element={<ManageElectricity />}
              />

              {/* Telephone & Internet Route */}
              <Route
                path="/add-telephone-n-internet"
                element={<AddTelephoneInternet />}
              />
              <Route
                path="/manage-telephone-n-internet"
                element={<ManageTelephoneInternet />}
              />

              {/* Petrol Route */}
              <Route path="/add-petrol" element={<AddPetrol />} />
              <Route path="/manage-petrol" element={<ManagePetrol />} />

              {/* Miscellaneous Route */}
              <Route path="/add-miscellaneous" element={<AddMiscellaneous />} />
              <Route
                path="/manage-miscellaneous"
                element={<ManageMiscellaneous />}
              />

              {/* Report */}
              <Route path="/expense-report" element={<ExpenseReport />} />

              {/* Send Email */}
              <Route path="/send-email-to-staff" element={<EmailToStaff />} />
              <Route
                path="/sent-email-to-staff"
                element={<SentEmailsToStaff />}
              />

              {/* Hot Client */}
              <Route path="/hot-clients" element={<HotClientList />} />

              {/* Sales Pipeline */}
              <Route
                path="/add-sales-pipeline"
                element={<AddSalesPipeline />}
              />
              <Route
                path="/manage-sales-pipeline"
                element={<ManageSalesPipeline />}
              />

              {/* Menu Access */}
              <Route path="/add-menu-access" element={<AddMenuAccess />} />
              {/* <Route path="/manage-sales-pipeline" element={<ManageSalesPipeline />} /> */}
              <Route path="/dynamic-table" element={<DynamicTable />} />

              {/* Worksheet Route */}
              <Route path="/work-sheet" element={<Worksheet />} />

              {/* Deleted Worksheet Route */}
              <Route path="/deleted-worksheet" element={<DeletedWorksheet />} />

              {/* Blog Route */}
              <Route path="/add-blog" element={<AddBlog />} />
              <Route path="/manage-blog" element={<ManageBlog />} />

              {/* User Remarks on Properties */}
              <Route path="/remarks-on-property" element={<UserRemarks />} />

              {/* Deals */}
              <Route path="/view-deals" element={<ClientListing />} />

              {/* Jobs */}
              <Route path="/add-job-category" element={<AddJobCategory />} />
              <Route
                path="/manage-job-category"
                element={<ManageJobCategory />}
              />
              <Route path="/add-job-post" element={<AddJobPost />} />
              <Route path="/manage-job-post" element={<ManageJobPosts />} />
              <Route path="/job-applications" element={<JobApplications />} />

              {/* Promotion */}
              <Route path="/add-promotion" element={<AddPromotion />} />
              <Route path="/manage-promotion" element={<ManagePromotion />} />

              {/* Reels */}
              <Route path="/add-reels" element={<AddReels />} />
              <Route path="/manage-reels" element={<ManageReels />} />
              {/* Blog Category Route */}
              <Route path="/add-blog-category" element={<AddBlogCategory />} />
              <Route
                path="/manage-blog-category"
                element={<ManageBlogCategory />}
              />
            </Route>
          </Route>
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
